<template>
    <ies-form-field :field="field">
        <!-- list must be list of ['text' => x, 'value' => y] -->
        <v-autocomplete hide-details dense outlined
            v-model="viewValue"
            :items="rateBases"
            autocomplete
        ></v-autocomplete>
        <input type="hidden" :name="field.fieldName" :value="field.value">
    </ies-form-field>

</template>

<script>
    /**
     * Allows the selection of rate basis for hotel room
     */
    export default {
        name: 'ies-input-rate-basis',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                rateBases: [
					{ text: 'Room', 		value: 1 },
					{ text: 'Apartment', 	value: 2 },
					{ text: 'Cottage', 		value: 3 },
					{ text: 'Villa', 		value: 4 },
					{ text: 'House', 		value: 5 },
					{ text: 'Boat', 		value: 6 },
					{ text: 'Unit', 		value: 7 },
					{ text: 'Whole House', 	value: 8 }
				],
                viewValue: parseInt(this.field.value),
            }
        },
        methods: {
            
        },
        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
            }
        }
    }
</script>

